import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    UtensilsCrossed, BedDouble, ShoppingBag, HeartPulse,
    Sparkles, Dumbbell, Plane, Clapperboard, Store, Loader2,
} from "lucide-react";
import { setSelectedCategory } from "../../store/storeCategoriesSlice";

const ICONS = {
    Dining: UtensilsCrossed,
    Hotels: BedDouble,
    Shopping: ShoppingBag,
    Health: HeartPulse,
    Beauty: Sparkles,
    Fitness: Dumbbell,
    Travel: Plane,
    Entertainment: Clapperboard,
};

export default function StoreCategories({ onSelect }) {
    const dispatch = useDispatch();
    const { items, loading, error, selected } = useSelector((s) => s.storeCategories);

    if (loading) {
        return (
            <div className="w-full max-w-2xl mt-6 flex items-center gap-2 text-sm text-gray-400">
                <Loader2 size={14} className="animate-spin" /> Loading categories...
            </div>
        );
    }
    if (error) {
        return <p className="w-full max-w-2xl mt-6 text-sm text-red-600">{error}</p>;
    }
    if (!items.length) return null;

    const handleClick = (name) => {
        dispatch(setSelectedCategory(name));
        onSelect?.(name);
    };

    return (
        <div className="w-full max-w-2xl mt-6">
            <div className="flex gap-3 overflow-x-auto pb-2 md:justify-center md:flex-wrap md:overflow-visible">
                {items.map((name) => {
                    const Icon = ICONS[name] || Store;
                    const active = selected === name;
                    return (
                        <button
                            key={name}
                            type="button"
                            onClick={() => handleClick(name)}
                            className={`shrink-0 w-[84px] flex flex-col items-center gap-2 px-2 py-3 rounded-2xl border bg-white transition-colors ${
                                active
                                    ? "border-[#0B67FC] ring-2 ring-[#0B67FC]/30"
                                    : "border-gray-200 hover:border-[#0B67FC]/60"
                            }`}
                        >
                            <Icon size={22} className="text-[#0B67FC]" />
                            <span className="text-[11px] font-medium text-gray-600 truncate w-full text-center">
                                {name}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}